import React, { FC, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import queryString from 'query-string';
import TemplatesTabPane from './templates/templates-tab-pane';
import FormsList from './form/practical-form-list';
import { RouteComponentProps } from 'react-router';
import { IdentityService, Roles } from 'services/identity-service';
import { container } from 'inversify.config';
import MRPracticalQuestionBankList from './mr-question-bank/mr-practical-question-bank-list';
import NMRPracticalQuestionBankList from './nmr-question-bank/nmr-practical-question-bank-list';
import LineSeparator from 'widgets/bussiness/line-separator';

export interface PracticalTestHomeProps extends RouteComponentProps, WithTranslation {}
export interface FeedbacksHomeState {
  activeIndex: number;
}

const PracticalTestHomePage: FC<PracticalTestHomeProps> = ({ t, match, history, location, staticContext }) => {
  const identityService: IdentityService = container.get(IdentityService);

  const routes: RouteComponentProps = {
    match,
    history,
    location,
    staticContext
  };

  const panes = [
    {
      menuItem: t('MR Question Bank'),
      render: () => (
        <Tab.Pane attached={false}>
          <MRPracticalQuestionBankList {...routes} />
        </Tab.Pane>
      )
    },
    {
      menuItem: t('NMR Question Bank'),
      render: () => (
        <Tab.Pane attached={false}>
          <NMRPracticalQuestionBankList {...routes} />
        </Tab.Pane>
      )
    },
    {
      menuItem: t('Templates'),
      render: () => (
        <Tab.Pane attached={false}>
          <TemplatesTabPane {...routes} />
        </Tab.Pane>
      )
    },
    {
      menuItem: t('Forms'),
      render: () => (
        <Tab.Pane attached={false}>
          <FormsList {...routes} />
        </Tab.Pane>
      )
    }
  ];
  const getActiveIndex = (): number => {
    let values = queryString.parse(location.search);
    if (values == null || values.tab == null) values = match.params;

    if (values == null || values.tab == null) return 0;

    let v: string;
    if (values.tab.constructor === Array) v = values.tab[0];
    else v = values.tab as string;
    const n = Number.parseInt(v);
    if (!Number.isNaN(n) && Number.isInteger(n) && Number.isFinite(n) && n >= 0 && n < panes.length) return n;
    return 0;
  };

  const [activeIndex, setActiveIndex] = useState(getActiveIndex());

  const isInRoleAdmin = (): boolean => IdentityService.isAdminOrPowerInstructor(identityService.getUserInfo());
  const isInRolePoC = (): boolean => identityService.isInRole(Roles.PoC);

  const onTabChange = (_, { activeIndex }) => {
    history.replace(`/assessments/practical-test?tab=${activeIndex}`);
    setActiveIndex(activeIndex);
  };

  return (
    <>
      {isInRoleAdmin() ? (
        <>
          <h3 id="feedback-forms-list-filters__title">{t('Practical Test')}</h3>
          <Tab
            className="main-tab"
            menu={{ secondary: true, pointing: true }}
            panes={panes}
            activeIndex={activeIndex}
            onTabChange={onTabChange}
          />
        </>
      ) : isInRolePoC() ? (
        <>
          <h3 id="feedback-forms-list-filters__title">{t('Practical Test')}</h3>
          <LineSeparator />
          <FormsList {...routes} />
        </>
      ) : null}
    </>
  );
};

export default withTranslation()(PracticalTestHomePage);
